import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ToastService } from '@plugins/client/toast/toast.service';

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      toastService.show({
        color: 'red',
        message: error.message,
        closeTimeout: 5000,
      });
      return throwError(() => error);
    }),
  );
};
